import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '../icon_progress/element.js';
import style from './style.lit.css';
import translations from './translations.js';

/**
 * Main title will go through main slot to have text in HTML on start.
 * Status text which is more informative can come later with component as it
 * will be dynamically generated based on step property and translations.
 *
 * @prop href - Url of profile setup page
 * @prop step - Current step of profile setup process
 * @prop totalSteps - Number of total steps of profile setup process
 *
 * @slot default - For profile status text
 */

export default class ProfileStatus extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  /** @internal */
  static translations = translations;

  static properties = {
    href: { type: String },
    step: { type: Number },
    totalSteps: { type: Number },
  };

  /** @internal */
  get done() {
    return this.step >= this.totalSteps;
  }

  /** @internal */
  get progress() {
    return Math.round((this.step / this.totalSteps) * 100);
  }

  /** @internal */
  get translatedStatus() {
    return this.t('status', { current: this.step, total: this.totalSteps });
  }

  render() {
    return html`
      <a href=${this.href}>
        <xs-icon-progress value=${this.progress}></xs-icon-progress>
        <section>
          <slot></slot>
          <footer>${this.translatedStatus}</footer>
        </section>
        <ef-icon name="chevron-right"></ef-icon>
      </a>
    `;
  }
}

ProfileStatus.registerTagName('xs-profile-status');

customElements.get('xs-profile-status') ||
  customElements.define('xs-profile-status', ProfileStatus);
